import { getRaw, hasRaw } from './raw'
import { unwrapLegacyExtras } from './legacy-extras'

/** Wire JSON for a stored record. A record that still carries `$raw` is re-parsed from that payload. */
export function jsonFromStorage(stored: unknown): unknown {
  if (stored && typeof stored === 'object' && hasRaw(stored)) {
    return getRaw(stored)
  }

  return unwrapLegacyExtras(stored)
}

/** Wire-shaped entity for IndexedDB. */
export function normalizeEntityForStorage<T>(
  entity: T,
  factory: { make: (json: unknown) => T; getTableName?: () => string }
): T {
  if (!entity || typeof entity !== 'object') {
    return entity
  }

  if (hasRaw(entity)) {
    return getRaw(entity) as T
  }

  const toJson = (entity as { toJSON?: () => unknown }).toJSON
  if (typeof toJson === 'function') {
    return factory.make(toJson.call(entity))
  }

  return entity
}
